module.exports = __webpack_public_path__ + "static/media/fiends-academy-logo.e602b31f.png";